import './src/main.css'
import Decoration9 from './src/main.vue'

export default function (Vue) {
  Vue.component(Decoration9.name, Decoration9)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/decoration9/index.js